import ProjectData from '@/types/ProjectData'

export default class RoomData {
  name = ''
  area = 0.0 as number
  floor = false
  plaster = false
  board = false
  cdp400 = false
  slab16 = false
  whDplt = false
  whDpld = false
  whComb = false
  whDpltL = false
  rpRtd = false
  rpCtm = false

  replacer = (key: any, value: any) => { // eslint-disable-line
    if (key !== 'attrDesc') return value
  }

  static attrDesc = {
    floor: {
      name: 'Padlófűtés',
      unit: 'm2'
    },
    plaster: {
      name: 'Vakolatos<br>mennyezeti',
      unit: 'm2'
    },
    board: {
      name: 'Gipszkartonos<br>mennyezeti',
      unit: 'm2'
    },
    cdp400: {
      name: 'CDP-400<br/>mennyezeti',
      unit: 'm2'
    },
    slab16: {
      name: 'SLAB-16<br>mennyezeti',
      unit: 'm2'
    },
    whDplt: {
      name: 'WH-DPLT',
      unit: 'pc',
      dependsOn: 'hasPro' as keyof ProjectData
    },
    whDpld: {
      name: 'WH-DPLD',
      unit: 'pc',
      dependsOn: 'hasPro' as keyof ProjectData
    },
    whComb: {
      name: 'WH-COMB',
      unit: 'pc',
      dependsOn: 'hasPro' as keyof ProjectData
    },
    whDpltL: {
      name: 'WH-DPLT-L',
      unit: 'pc',
      dependsOn: 'hasPro2' as keyof ProjectData
    },
    rpRtd: {
      name: 'RP-RTD',
      unit: 'pc',
      dependsOn: 'hasWatts' as keyof ProjectData
    },
    rpCtm: {
      name: 'RP-CTM',
      unit: 'pc',
      dependsOn: 'hasWatts' as keyof ProjectData
    }
  }
}
